import { BaseState } from '@/store/base-state';

export default class CompaniesUsersState extends BaseState {}
